import axios from "axios";
import { aspNetUrl, newApiBaseUrl } from "../../axiosInstance";
import {
  formatMediaOrder,
  resolveMediaDefaultFlag,
  resolveMediaDefaultFromSourceOrFallback,
} from "../utils/productMedia";

export const UploadImage = (data) => {
  return axios.post(`${aspNetUrl}UploedImage`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const getImgAdmin = () => {
  return axios.get(`${aspNetUrl}ImageForAdmin`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

const toImagesPayload = (media, images) => {
  if (Array.isArray(images) && images.length) return images;
  if (Array.isArray(media) && media.length) return media;
  if (media != null) return [media];
  return [];
};

/** PIM may store `isDefault` and/or `default` — always send explicit booleans. */
export const buildPimImagePayload = (img, index = 0) => {
  const isDefault = resolveMediaDefaultFlag(img);
  const payload = {
    path: img.path,
    size: img.size || 0,
    order: index,
    default: isDefault,
    isDefault: isDefault,
  };

  if (img.width != null) payload.width = img.width;
  if (img.height != null) payload.height = img.height;
  if (img.source !== undefined) payload.source = img.source;

  return payload;
};

export const deleteProductMedia = ({ productId, branch, path }) => {
  if (!productId || branch == null || !path) {
    return Promise.reject(
      new Error("deleteProductMedia: missing productId, branch, or path"),
    );
  }

  const params = new URLSearchParams({
    branch: String(branch),
    path: String(path),
  });

  return axios.delete(
    `${newApiBaseUrl}/products/${productId}/media?${params.toString()}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const updateImgProduct = (data) => {
  const { productId, media, images, ...rest } = data;
  const imageList = toImagesPayload(media, images).map((img, index) =>
    buildPimImagePayload(img, formatMediaOrder(img.order, index)),
  );

  return axios.put(
    `${newApiBaseUrl}/products/${productId}/image`,
    { images: imageList, ...rest },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const parseUploadedProductMedia = (data, fallbackMedia) => {
  if (Array.isArray(data?.images) && data.images.length) {
    return data.images.map((img, i) => ({
      path: typeof img === "string" ? img : img?.path || "",
      size: typeof img === "object" ? img.size || 0 : fallbackMedia?.size || 0,
      order: formatMediaOrder(
        typeof img === "object" ? img.order : undefined,
        i,
      ),
      width: typeof img === "object" ? img.width : fallbackMedia?.width,
      height: typeof img === "object" ? img.height : fallbackMedia?.height,
      source: typeof img === "object" ? img.source : fallbackMedia?.source,
      default: resolveMediaDefaultFromSourceOrFallback(
        typeof img === "object" ? img : null,
        i === 0 ? fallbackMedia : null,
      ),
    }));
  }

  if (Array.isArray(data?.addedImages) && data.addedImages.length) {
    return data.addedImages.map((name, i) => ({
      path: typeof name === "string" ? name : name?.path || "",
      order: i,
      default: resolveMediaDefaultFromSourceOrFallback(
        null,
        i === 0 ? fallbackMedia : null,
      ),
      size: fallbackMedia?.size || 0,
      width: fallbackMedia?.width,
      height: fallbackMedia?.height,
      source: fallbackMedia?.source,
    }));
  }

  if (Array.isArray(data?.media) && data.media.length) {
    return data.media.map((img, i) => ({
      path: img.path,
      size: img.size || 0,
      order: formatMediaOrder(img.order, i),
      width: img.width,
      height: img.height,
      source: img.source,
      default: resolveMediaDefaultFromSourceOrFallback(
        img,
        i === 0 ? fallbackMedia : null,
      ),
    }));
  }

  if (!fallbackMedia) return [];

  return [
    {
      path: fallbackMedia.path,
      size: fallbackMedia.size || 0,
      order: formatMediaOrder(fallbackMedia.order, 0),
      width: fallbackMedia.width,
      height: fallbackMedia.height,
      source: fallbackMedia.source,
      default: resolveMediaDefaultFromSourceOrFallback(null, fallbackMedia),
    },
  ];
};

export const UploadImageData = (data) => {
  const formData = new FormData();

  let imageToUpload = data.selectedFile;
  if (
    data.selectedFile &&
    typeof data.selectedFile === "string" &&
    data.selectedFile.startsWith("data:image")
  ) {
    const dataUrlToBlob = (dataUrl) => {
      const byteString = atob(dataUrl.split(",")[1]);
      const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
      const arrayBuffer = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        arrayBuffer[i] = byteString.charCodeAt(i);
      }
      return new Blob([arrayBuffer], { type: mimeString });
    };
    imageToUpload = dataUrlToBlob(data.selectedFile);
  }

  formData.append("Image", imageToUpload);
  formData.append("FileName", data.FileName);
  formData.append("Mkt", data.Mkt);
  formData.append("ItemId", data.ItemId);

  if (data.IdImgGs1) {
    formData.append("IdImgGs1", data.IdImgGs1);
  }
  if (data.SourceImgId) {
    formData.append("SourceImgId", data.SourceImgId);
  }

  return axios.post(`${aspNetUrl}Product/UploadImageToServer`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const deleteImageFromServer = (data) => {
  const formData = new FormData();
  formData.append("Mkt", data.Mkt);
  formData.append("ItemId", data.ItemId);
  formData.append("FileName", data.FileName);

  return axios.post(`${aspNetUrl}Product/DeleteImageFromServer`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
